import { PageComponent } from '@root/pages/Type';
import classNames from 'classnames';
import React, { ReactNode } from 'react';
import styles from './Title.module.scss';

export type TitleProps = {
    title: string | ReactNode;
    className?: string;
};

const Title: PageComponent<TitleProps> = ({ children, title, className }) => (
    <div className={styles.container_title}>
        <h1 className={classNames(styles.title, className)}>{title}</h1>
        {React.Children.map(children, (child) => {
            return child;
        })}
    </div>
);

export default Title;
